export default __webpack_public_path__ + "static/media/exam-details-header2.8cd34b05.jpg";